import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface ComparisonBadgeProps {
  value: number;
  suffix?: string;
  inverse?: boolean; // If true, negative is good (e.g., bounce rate)
}

export const ComparisonBadge = ({ value, suffix = "%", inverse = false }: ComparisonBadgeProps) => {
  const isPositive = inverse ? value < 0 : value > 0;
  const isNegative = inverse ? value > 0 : value < 0;
  const isNeutral = value === 0;

  const Icon = isNeutral ? Minus : isPositive ? TrendingUp : TrendingDown;
  const variant = isNeutral ? "secondary" : isPositive ? "default" : "destructive";
  const sign = value > 0 ? "+" : "";

  return (
    <Badge variant={variant} className="gap-1">
      <Icon className="h-3 w-3" />
      <span className="text-xs font-medium">
        {sign}{Math.abs(value).toFixed(1)}{suffix}
      </span>
    </Badge>
  );
};
